import { render, staticRenderFns } from "./RxInformationPopup.vue?vue&type=template&id=cfad8e1a&scoped=true&"
import script from "./RxInformationPopup.vue?vue&type=script&lang=js&"
export * from "./RxInformationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfad8e1a",
  null
  
)

export default component.exports